import { useEffect, useRef } from 'react';
import useContextActions from '../../useContextActions';

/**
 * Custom hook that provides a reference to the filters bar element and updates the filters bar height in the context.
 * @param {object} options - The options object.
 * @param {object} options.Context - The context object.
 * @returns {object} - The filters bar reference.
 */
const useFiltersBarRef = ({ Context }) => {
  const contextActions = useContextActions({ Context });

  const filtersBarRef = useRef(null);

  useEffect(() => {
    const handleResize = entries => {
      for (const entry of entries) {
        const { offsetHeight } = entry.target;
        contextActions.onChangeFiltersBarHeight(offsetHeight);
      }
    };

    const observer = new ResizeObserver(handleResize);

    if (filtersBarRef.current) {
      observer.observe(filtersBarRef.current);
    }

    return () => {
      if (filtersBarRef.current) {
        observer.unobserve(filtersBarRef.current);
      }
    };
  }, [filtersBarRef.current]);

  return filtersBarRef;
};

export default useFiltersBarRef;
